var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 7.49935C2.5 5.6584 3.99238 4.16602 5.83333 4.16602H14.1667C16.0076 4.16602 17.5 5.6584 17.5 7.49935V14.166C17.5 16.0069 16.0076 17.4993 14.1667 17.4993H5.83333C3.99238 17.4993 2.5 16.0069 2.5 14.166V7.49935ZM5.83333 5.83268C4.91286 5.83268 4.16667 6.57887 4.16667 7.49935V14.166C4.16667 15.0865 4.91286 15.8327 5.83333 15.8327H14.1667C15.0872 15.8327 15.8333 15.0865 15.8333 14.166V7.49935C15.8333 6.57887 15.0872 5.83268 14.1667 5.83268H5.83333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66732 2.5C7.12755 2.5 7.50065 2.8731 7.50065 3.33333V5C7.50065 5.46023 7.12755 5.83333 6.66732 5.83333C6.20708 5.83333 5.83398 5.46023 5.83398 5V3.33333C5.83398 2.8731 6.20708 2.5 6.66732 2.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 2.5C13.7936 2.5 14.1667 2.8731 14.1667 3.33333V5C14.1667 5.46023 13.7936 5.83333 13.3333 5.83333C12.8731 5.83333 12.5 5.46023 12.5 5V3.33333C12.5 2.8731 12.8731 2.5 13.3333 2.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50065 8.33333C7.50065 8.79358 7.12755 9.16667 6.66732 9.16667C6.20708 9.16667 5.83398 8.79358 5.83398 8.33333C5.83398 7.8731 6.20708 7.5 6.66732 7.5C7.12755 7.5 7.50065 7.8731 7.50065 8.33333Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8327 8.33333C10.8327 8.79358 10.4596 9.16667 9.99935 9.16667C9.5391 9.16667 9.16602 8.79358 9.16602 8.33333C9.16602 7.8731 9.5391 7.5 9.99935 7.5C10.4596 7.5 10.8327 7.8731 10.8327 8.33333Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 8.33333C14.1667 8.79358 13.7936 9.16667 13.3333 9.16667C12.8731 9.16667 12.5 8.79358 12.5 8.33333C12.5 7.8731 12.8731 7.5 13.3333 7.5C13.7936 7.5 14.1667 7.8731 14.1667 8.33333Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50065 11.6673C7.50065 12.1276 7.12755 12.5007 6.66732 12.5007C6.20708 12.5007 5.83398 12.1276 5.83398 11.6673C5.83398 11.2071 6.20708 10.834 6.66732 10.834C7.12755 10.834 7.50065 11.2071 7.50065 11.6673Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender12);
export default __webpack_public_path__ + "static/media/calender12.918b2635a67b2bc9be2966232ebc57ba.svg";
export { ForwardRef as ReactComponent };